import { GaugeArc } from "./GaugeArc";
export default GaugeArc;
